import { Platform } from 'react-native';
import { DynamicStyleSheet } from '@pulsar/core';

export default DynamicStyleSheet.create(theme => ({
  root: {
    backgroundColor: theme.colors.searchBarBG,
    borderRadius: Platform.select(theme.radii),
    overflow: 'hidden',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: theme.space[3],
  },
  rootPaddingRight: {
    paddingRight: theme.space[2],
  },
  input: {
    backgroundColor: theme.colors.searchBarBG,
    height: 36,
    flexGrow: 1,
    flexShrink: 1,
    ...theme.fonts.headline,
  },
  icon: {
    color: theme.colors.searchBarIcon,
    marginRight: theme.space[2],
  },
  button: {
    color: theme.colors.searchBarIcon,
    height: 36,
    width: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
